var m = require('mithril');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var fieldnetTree = require('../../network/components/fieldnetTree');

var overrideValue = Object.create(Model);

overrideValue.name = 'OverrideValue';
overrideValue['@class'] = 'OverrideValue';
overrideValue.url = 'overridevalue';

overrideValue.fields = {
  out: {
    validators : {
      presence: true
    }
  },
  in: {
    validators: {
      presence: true
    }
  }
};

overrideValue.view = function (ctrl) {
  return m(fieldnetTree, {selectedPoint: overrideValue.form.in});
};

module.exports = overrideValue;
